export function saveEventHistoryToList(eventHistory: Record<string,  any>) {
	try {
		let eventHistoryItem = localStorage.getItem("eventhistory");
		let eventHistoryList: Record<string,  any>[];
		if (eventHistoryItem) {
			eventHistoryList = JSON.parse(eventHistoryItem) as Record<string,  any>[];
			eventHistoryList.push(eventHistory);
		} else {
			eventHistoryList = [eventHistory];
		}
		
		// Keep only the last 100 items
		if (eventHistoryList.length > 100) {
			eventHistoryList = eventHistoryList.slice(-100);
		}
		
		localStorage.setItem("eventhistory", JSON.stringify(eventHistoryList));	
	} catch (error) { 
		console.error("Error saving event history to list:", error);
	}
}

const getEventHistoryBy = (field: "invoiceNumber" | "sku" | "transferSourceId", value: any) => {
	let eventHistoryItem = localStorage.getItem("eventhistory");
	let eventHistoryList: Record<string,  any>[] = [];
	if (eventHistoryItem) {
		eventHistoryList = JSON.parse(eventHistoryItem) as Record<string,  any>[];
		eventHistoryList = eventHistoryList.filter((item) => item[field] === value);
		eventHistoryList = eventHistoryList.sort((a, b) => {
			if (a.date > b.date) return -1;
			if (a.date < b.date) return 1;
			return 0;
		});
	}
	return eventHistoryList;
}

export function getEventHistoryListByInvoiceNumber(invoiceNumber: string) {
	return getEventHistoryBy("invoiceNumber", invoiceNumber)
}

export function getEventHistoryListBySku(sku: string) {
	return getEventHistoryBy("sku", sku)
}

export function getEventHistoryListByTransferSourceId(sourceId: string) {
	return getEventHistoryBy("transferSourceId", sourceId)
}